import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

const LoadingExpenses = (): JSX.Element => {
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box>
        <CircularProgress />
      </Box>
      <Typography fontSize={'16px'} fontWeight={500}>
        Loading expenses
      </Typography>
      <Typography fontSize={'14px'}>Might take a few seconds</Typography>
    </Stack>
  );
};

export default LoadingExpenses;
